import { connect } from 'react-redux';

import Basket from '../components/Basket';
import { isUserLoggedIn } from 'apps/user/helpers';
import { openTrolleyMenu } from 'apps/trolleyMenu/actions/trolleyMenu';
import { changeBasketQuantity } from 'apps/basket/actions/basket';

import { withMediaQueryDesktop } from 'lib/utils/mediaQueries/withMediaQueries';

export default connect(
  state => ({
    basket: state.basket,
    isLoggedIn: isUserLoggedIn(state.user),
  }),
  {
    openTrolleyMenu,
    changeBasketQuantity,
  }
)(withMediaQueryDesktop(Basket));
